import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/sections/HeroSection";
import { WorkSection } from "@/sections/WorkSection";
import { AboutSection } from "@/sections/AboutSection";
import { TestimonialsSection } from "@/sections/TestimonialsSection";
import { ContactSection } from "@/sections/ContactSection";
import { Footer } from "@/sections/Footer";
import { CaseStudy } from "@/pages/CaseStudy";
import { UnicredsCaseStudy } from "@/pages/UnicredsCaseStudy";
import { ScrollToHash } from "@/components/ScrollToHash";

const Portfolio = () => {
  return (
    <div className="App" data-testid="portfolio-root">
      
      <Navigation />
      <main>
        <HeroSection />
        <WorkSection />
        <AboutSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/work/unicreds-crm" element={<UnicredsCaseStudy />} />
        <Route path="/work/:id" element={<CaseStudy />} />
        <Route path="*" element={<Portfolio />} />
      </Routes>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#0E1A2B",
            border: "1px solid #E4E6EC",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
